import type { ReactNode } from 'react';
import styles from './ProductGrid.module.css';

export interface ProductFrame {
  src: string;
  alt: string;
  caption?: ReactNode;
}

interface ProductGridProps {
  frames: ProductFrame[];
}

export default function ProductGrid({ frames }: ProductGridProps) {
  return (
    <div className={styles.grid} style={{ ['--cols' as never]: frames.length }}>
      {frames.map((f, i) => (
        <div key={i} className={styles.frame}>
          <img src={f.src} alt={f.alt} />
          {f.caption && <div className={styles.caption}>{f.caption}</div>}
        </div>
      ))}
    </div>
  );
}
